module.exports = __webpack_public_path__ + "static/media/gallery29.a6d5abfe.jpeg";